module.exports = __webpack_public_path__ + "img/sleeping-ale-bot.949bb61f.png";